<template>
	<div class="cart">
		<Modal
			:show="showPaymentModal"
			content_class="col-12 col-md-9 col-lg-7 col-xl-5 confirm-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix top">
						<div class="left-content f-l">
							<div class="content-title">
								Payment Confirmation
							</div>
						</div>
						<div class="close-modal f-r" @click="closeModal(0)">
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div
						class="row"
						v-if="paymentPage == 1 && selectedProduct.product_name"
					>
						<div class="col-12 col-lg-11 col-xl-10">
							<div class="cart-item">
								<div class="row">
									<div class="col-12 col-md-8 col-lg-7">
										<div class="item-box clearfix">
											<div
												class="icon-box blue f-l"
											></div>
											<div class="detail-box f-l">
												<div class="item-name">
													{{
														selectedProduct.product_name
													}}
												</div>
												<div class="insurance">
													{{
														selectedProduct.underwritter_name
													}}
												</div>

												<div
													class="categories clearfix"
												>
													<div class="category f-l">
														<div class="name f-l">
															Added:
															{{
																moment(
																	selectedProduct.created_date,
																).format(
																	'ddd Do',
																)
															}}
														</div>
														<div
															class="circle f-l"
														></div>
													</div>
													<div class="category f-l">
														<div class="name f-l">
															{{
																moment(
																	selectedProduct.created_date,
																).format('MM')
															}}
														</div>
														<div
															class="circle f-l"
														></div>
													</div>
													<div class="category f-l">
														<div class="name f-l">
															{{
																moment(
																	selectedProduct.created_date,
																).format('YYYY')
															}}
														</div>
														<div
															class="circle f-l"
														></div>
													</div>
												</div>
												<div class="price">
													Premium:
													{{
														selectedProduct
															.product_account_details
															.currency_code
													}}{{
														utils.numberWithCommas(
															selectedProduct
																.invoice_details
																.premium_amount,
														)
													}}
												</div>
											</div>
										</div>
									</div>
									<div class="col-12">
										<div class="math-box">
											<div class="row">
												<div class="col-12">
													<div class="title-charge">
														Charges
													</div>
												</div>
												<div
													class="col-12"
													v-for="(
														charge, index
													) in selectedProduct
														.invoice_details
														.charges"
													:key="index"
												>
													<div class="item">
														<div class="row">
															<div class="col-8">
																<div
																	class="title"
																>
																	{{
																		charge.name
																	}}
																</div>
															</div>
															<div class="col-4">
																<div
																	class="num"
																>
																	{{
																		selectedProduct
																			.product_account_details
																			.currency_code
																	}}
																	{{
																		utils.numberWithCommas(
																			Math.round(
																				charge.amount *
																					100,
																			) /
																				100,
																		)
																	}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12">
													<div class="item">
														<div class="row">
															<div class="col-8">
																<div
																	class="title"
																>
																	Premium
																	Amount
																</div>
															</div>
															<div class="col-4">
																<div
																	class="num"
																>
																	{{
																		selectedProduct
																			.product_account_details
																			.currency_code
																	}}
																	{{
																		utils.numberWithCommas(
																			Math.round(
																				selectedProduct
																					.invoice_details
																					.premium_amount *
																					100,
																			) /
																				100,
																		)
																	}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12">
													<div class="item total">
														<div class="row">
															<div class="col-8">
																<div
																	class="title"
																>
																	TOTAL
																</div>
															</div>
															<div class="col-4">
																<div
																	class="num"
																>
																	{{
																		selectedProduct
																			.product_account_details
																			.currency_code
																	}}
																	{{
																		utils.numberWithCommas(
																			Math.round(
																				selectedProduct
																					.invoice_details
																					.total_amount *
																					100,
																			) /
																				100,
																		)
																	}}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="card c-action">
								<div class="actions">
									<button
										class="btn btn-grey"
										@click="closeModal(0)"
									>
										Cancel
									</button>
									<button
										class="btn btn-yellow"
										:disabled="loading"
										@click="payInvoice()"
									>
										Proceed
										<div class="lds-ring" v-show="loading">
											<div></div>
											<div></div>
											<div></div>
											<div></div>
										</div>
									</button>
								</div>
							</div>
						</div>
					</div>

					<div class="row" v-if="paymentPage === 2">
						<div
							class="col-12 col-lg-11 col-xl-10 success"
							v-show="paymentComplete"
						>
							<div class="msg-box">
								<img src="/img/group.svg" alt="" />
								<div class="msg-text">Success</div>
							</div>
							<div class="card card-details">
								<div class="top">
									<div class="icon-box f-l"></div>
									<div class="detail-box f-l">
										<div class="item-name">
											{{ selectedProduct.product_name }}
										</div>
										<div class="insurance">
											{{
												selectedProduct.underwritter_name
											}}
										</div>
									</div>
									<div class="price-box f-r">
										-
										{{
											selectedProduct
												.product_account_details
												.currency_code
										}}{{
											utils.numberWithCommas(
												Math.round(
													selectedProduct
														.invoice_details
														.total_amount * 100,
												) / 100,
											)
										}}
									</div>
								</div>
								<div class="bottom">
									Successfully purchased
									<b>{{ selectedProduct.product_name }}</b>
									from
									<b>{{
										selectedProduct.underwritter_name
									}}</b
									>. Your balance is
									<b
										>{{
											selectedProduct
												.product_account_details
												.currency_code
										}}{{
											utils.numberWithCommas(
												Math.round(balance * 100) / 100,
											)
										}}</b
									>
								</div>
							</div>

							<div class="mt-5 c-action">
								<div
									class="btn btn-yellow"
									@click="closeModal(0)"
								>
									Cancel
								</div>
							</div>
						</div>
						<div
							class="col-12 col-lg-11 col-xl-10 error"
							v-show="!paymentComplete"
						>
							<div class="msg-box">
								<img src="/img/processing.svg" alt="" />
								<div class="msg-text tx-red">Error</div>
							</div>
							<div class="card card-details">
								<div class="top">
									<div class="icon-box f-l"></div>
									<div class="detail-box f-l">
										<div class="item-name">
											{{ selectedProduct.product_name }}
										</div>
										<div class="insurance">
											{{
												selectedProduct.underwritter_name
											}}
										</div>
									</div>
									<div class="price-box f-r">
										-
										{{
											selectedProduct
												.product_account_details
												.currency_code
										}}{{
											utils.numberWithCommas(
												Math.round(
													selectedProduct
														.invoice_details
														.total_amount * 100,
												) / 100,
											)
										}}
									</div>
								</div>
								<div class="bottom">
									Sorry, we could not process your payment at
									the moment, kindly try again.
								</div>
							</div>

							<div class="mt-5 c-action">
								<div
									class="btn btn-yellow"
									@click="
										$store.commit('showIPFModal', false);
										$router.push({ name: 'TopUpOptions' });
									"
								>
									Top Up
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<Modal
			:show="showMessageModal"
			content_class="col-12 col-md-9 col-lg-7 col-xl-5 message-modal"
		>
			<template slot="content">
				<div>
					<div class="clearfix">
						<div class="close-modal f-r" @click="closeModal(2)">
							<i class="fa fa-times"></i>
						</div>
					</div>

					<div class="row justify-content-center">
						<div
							class="col-12 col-lg-11 col-xl-10 processing"
							v-show="processing"
						>
							<div class="msg-box">
								<img src="/img/processing.svg" alt="" />
								<div class="msg-text">Processing</div>
							</div>
							<div class="card card-details">
								<div class="top">
									<div class="icon-box f-l"></div>
									<div class="detail-box f-l">
										<div class="item-name">
											{{ selectedProduct.name }}
										</div>
										<div class="insurance">
											{{ selectedProduct.underwritter }}
										</div>
									</div>
									<div class="price-box f-r">
										- {{ selectedProduct.currency
										}}{{
											utils.numberWithCommas(
												selectedProduct.price,
											)
										}}
									</div>
								</div>
								<div class="bottom">
									Please wait while we process your payment.
									This shouldn’t take long.
								</div>
							</div>

							<div class="mt-5 c-action">
								<div class="btn btn-grey">Cancel</div>
							</div>
						</div>
						<div
							class="col-12 col-lg-11 col-xl-10 success"
							v-show="!processing && responseType === 'success'"
						>
							<div class="msg-box">
								<img src="/img/group.svg" alt="" />
								<div class="msg-text">Success</div>
							</div>
							<div class="card card-details">
								<div class="top">
									<div class="icon-box f-l"></div>
									<div class="detail-box f-l">
										<div class="item-name">
											{{ selectedProduct.name }}
										</div>
										<div class="insurance">
											{{ selectedProduct.underwritter }}
										</div>
									</div>
									<div class="price-box f-r">
										- {{ selectedProduct.currency
										}}{{
											utils.numberWithCommas(
												selectedProduct.price,
											)
										}}
									</div>
								</div>
								<div class="bottom">
									Successfully purchased
									<b>Ladies First Insurance</b> from
									<b>Sanlam Insurance Ltd</b>. Your balance is
									<b
										>{{ selectedProduct.currency
										}}{{ utils.numberWithCommas(6500) }}</b
									>
								</div>
							</div>

							<div class="card c-action">
								<div class="txt">
									Click here to track the status of your
									purchase
								</div>
							</div>
						</div>
						<div
							class="col-12 col-lg-11 col-xl-10 error"
							v-show="!processing && responseType === 'error'"
						>
							<div class="msg-box">
								<img src="/img/group.svg" alt="" />
								<div class="msg-text">Error</div>
							</div>
							<div class="card card-details">
								<div class="top">
									<div class="icon-box f-l"></div>
									<div class="detail-box f-l">
										<div class="item-name">
											{{ selectedProduct.name }}
										</div>
										<div class="insurance">
											{{ selectedProduct.underwritter }}
										</div>
									</div>
									<div class="price-box f-r">
										- {{ selectedProduct.currency
										}}{{
											utils.numberWithCommas(
												selectedProduct.price,
											)
										}}
									</div>
								</div>
								<div class="bottom">
									Sorry, we could not process your payment at
									the moment, kindly try again.
								</div>
							</div>

							<div class="mt-5 c-action">
								<div class="btn btn-yellow">Try Again</div>
								<div class="txt mt-3">Top Up My Account</div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</Modal>

		<div class="title-content clearfix">
			<div class="title f-l">My Cart</div>
			<div class="btn btn-primary f-r btn-sm">
				<i class="fa fa-shopping-cart"></i> Checkout All
			</div>
		</div>

		<div class="cart-content" v-if="cartItems.length > 0">
			<CartItem
				v-for="(item, index) in cartItems"
				:item="item"
				:key="index"
				@on-payment="openPaymentModal({ item })"
				@on-ipf="openIPFModal(item)"
				@on-delete="deleteInvoice(item)"
			/>
		</div>
		<div
			class="card-content col-12 col-lg-9"
			v-if="!cartItems || cartItems.length === 0"
		>
			<div class="white-content">
				<div class="title">No Cart Items Available</div>
			</div>
		</div>
	</div>
</template>

<script>
import cart from '../rsc/stores/cart.store';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	components: {
		Slider: () => import('@/libs/clarks/components/slider'),
		InputText: () => import('@/libs/clarks/components/text'),
		CartItem: () => import('../templates/others/cart-item'),
		Modal: () => import('../templates/others/modal'),
	},
	beforeDestroy() {
		this.$store.unregisterModule('cart');
	},
	created() {
		utils.registerModule('cart', cart, this.$store);
	},
	data() {
		return {
			utils,
			moment,
			processing: true,
			showMessageModal: false,
			showConfirmModal: false,
			showIPFModal: false,
			responseType: 'error',
		};
	},
	computed: {
		...mapGetters([
			'cartItems',
			'loading',
			'balance',
			'paymentPage',
			'showPaymentModal',
			'paymentComplete',
			'selectedProduct',
		]),
	},
	methods: {
		...mapActions([
			'fetchCartItems',
			'openIPFModal',
			'deleteInvoice',
			'openPaymentModal',
			'payInvoice',
		]),
		validateItem(form) {},
		makePayment(product) {
			this.selectedProduct = product;
			this.showConfirmModal = true;
		},
		requestIPF(product) {
			this.selectedProduct = product;
			this.showIPFModal = true;
		},
		closeModal(type) {
			if (type === 0) {
				this.$store.commit('showPaymentModal', false);
			} else if (type === 1) {
				this.showConfirmModal = false;
			} else if (type === 2) {
				this.showMessageModal = false;
			} else {
				this.showIPFModal = false;
			}
		},
		cartConfirmed(data) {
			this.showConfirmModal = true;
		},
	},
	async mounted() {
		utils.registerModule('cart', cart, this.$store);
		await this.fetchCartItems();
		Event.$emit('loader:show', false);
	},
};
</script>

<style lang="less">
.cart {
	.title-content {
		.btn-primary {
			width: auto !important;
		}
	}
	.card-content {
		.white-content {
			background: var(--white);
			border-radius: 4px;
			border: solid 1px #e6eaee;
			padding: 40px 0;
			text-align: center;
			font-size: 14px;
			font-weight: 600;
			color: var(--ne-red);
		}
	}

	.msg-box {
		text-align: center;
		margin: 25px 0;
	}

	.ipf-modal {
		.actions {
			margin: 10px 0 0 0;

			.price-box {
				.price {
					font-size: 20px;
					line-height: 15px;
					font-family: var(--font-bold);

					.point {
						font-size: 11px;
					}
				}

				.txt {
					color: var(--text-grey);
					font-size: 14px;
				}
			}

			.btn.btn-primary {
				display: inline-block;
				width: auto !important;
				color: var(--white);
				background: var(--primary);
				padding: 10px 20px;
				font-weight: 400;
			}

			.btn-primary:hover {
				background: lighten(#003c80, 10%);
			}
		}

		.card-details {
			.bottom {
				margin: 15px 0 0 0;
				color: #9c7bfc;
			}
		}

		.form-item {
			.txt {
				text-align: center;

				span {
					color: #9c7bfc;
				}
			}
		}
	}

	.detail-box {
		margin: 10px 0 0 0;

		.item-name {
			font-size: 18px;
			color: #464855;
			font-family: var(--font-bold);
			line-height: 15px;
		}

		.insurance {
			font-weight: 600;
			color: #6f7faf;
			font-size: 13px;
			color: #6f7faf;
		}
	}

	.icon-box {
		background: #eeeef2;
		width: 50px;
		height: 50px;
		border-radius: 20px;
		margin: 0 20px 0 0;
	}

	.message-modal {
		.success .msg-text {
			color: #34c47c;
		}

		.error .msg-text {
			color: #fa1c1c;
		}

		.processing .msg-text {
			color: #9c7bfc;
		}

		.msg-box {
			margin: 60px 0 0 0;
			text-align: center;

			img {
				max-width: 150px;
				width: auto;
				height: auto;
			}

			.msg-text {
				font-size: 15px;
				margin: 3px 0 0 0;
				font-weight: 600;
			}
		}

		.card-details {
			margin: 20px 0 0 0 !important;
		}

		.c-action {
			.txt {
				font-weight: 600;
				color: #9c7bfc;
				text-align: center;
				cursor: pointer;
			}

			.txt:hover {
				text-decoration: underline;
			}
		}

		.top {
			border-bottom: solid 1px #efefef;
			padding: 5px 0 15px 0;
			margin: 0 0 15px 0;

			b {
				color: #3c3b3b;
			}
		}

		.bottom {
			width: 90%;
		}
	}

	.price-box {
		background: #f8f8fa;
		color: #6f7faf;
		padding: 5px 10px;
		border-radius: 8px;
		font-weight: 600;
		margin: 3px 0 0 0;
	}

	.confirm-modal {
		.c-action {
			.link {
				margin: 5px 0 0 0;
				text-align: center;
				font-weight: 600;
				cursor: pointer;
				font-size: 16px;
			}

			.link:hover {
				color: var(--ne-yellow);
			}

			.actions {
				margin: 0 0 15px 0;
				display: flex;
			}
		}

		.card-details {
			padding: 22px 18px 0 18px;

			.top {
				border-bottom: solid 1px #efefef;
				padding: 5px 0 15px 0;
				margin: 0 0 15px 0;
			}

			.detail-box {
				margin: 10px 0 0 0;

				.item-name {
					font-size: 18px;
					color: #464855;
					font-family: var(--font-bold);
					line-height: 15px;
				}

				.insurance {
					font-weight: 600;
					color: #6f7faf;
					font-size: 13px;
					color: #6f7faf;
				}
			}

			.icon-box {
				background: #eeeef2;
				width: 50px;
				height: 50px;
				border-radius: 20px;
				margin: 0 20px 0 0;
			}
		}

		.summary {
			.f-r {
				text-align: right;
			}

			.title {
				font-size: 17px;
				font-weight: 600;
				margin: 0 0 8px 0;
			}

			.tpo {
				color: #8c8a9a;
			}

			.phkt {
				color: #9c7bfc;
				font-weight: 600;
			}

			.total {
				background: #f8f8fa;
				color: #6f7faf;
				font-size: 16px;
				font-weight: 600;
				margin: 15px -18px 0 -18px;
				padding: 8px 18px;
				border-radius: 0 0 4px 4px;
			}
		}
	}

	.payment-modal {
		padding: 30px;

		.content-title {
			margin: -10px 0 40px 0;
		}
	}

	.btn {
		width: 100%;
		margin: 0 10px;
	}

	.btn-yellow {
		background: var(--ne-yellow);
		color: var(--white);
	}

	.btn-grey {
		background: #bfc7d133;
	}

	.btn-grey:hover {
		background: darken(#bfc7d133, 5%);
		color: var(--text-color);
	}

	.btn-yellow:hover {
		background: darken(#ff9f00, 2%);
	}
}
</style>
